<template>
  <div class="parameters-config">
    <input-container v-for="(param,i) in values" :key="param.name"
      v-model="values[i]"
    />
  </div>
</template>

<script>
import InputContainer from '@/components/inputs/InputContainer'

export default {
  props: ['values'],
  components: {InputContainer},
  model:{
    prop: 'values',
    event: 'change'
  }
}
</script>

<style>

</style>